module.exports = __webpack_public_path__ + "static/img/8.49028fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quartos/duplo1/8.jpg
// module id = +5cN
// module chunks = 1